import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { getUser, getUser_v2 } from '../utils/dropdownlist'
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md'
import { FaEdit } from 'react-icons/fa'
import { IconContext } from 'react-icons/lib'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { CSVLink } from 'react-csv'

const headers = [
  {
    label: 'Payment ID',
    key: 'payment_id',
  },
  {
    label: 'Order ID',
    key: 'order_id',
  },
  {
    label: 'Store ID',
    key: 'store_id',
  },
  {
    label: 'Store Code',
    key: 'store_code',
  },
  {
    label: 'Customer Name',
    key: 'customer_name',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Payment Date',
    key: 'payment_date',
  },
  {
    label: 'Payment Amount',
    key: 'amount',
  },
  {
    label: 'Payment Type',
    key: 'payment_type',
  },
  {
    label: 'Order Amount',
    key: 'total_price',
  },
  {
    label: 'Order Status',
    key: 'order_status',
  },
  {
    label: 'Payment Status',
    key: 'payment_status',
  },
]

class ManagementPayment extends React.Component {
  _isMounted = true
  ManagementPaymentDetail = StorageService.getSession('ManagementPayment')
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      isLoading: true,
      // fm_date:
      //   this.storesalesDetail && this.storesalesDetail.fm_date
      //     ? this.storesalesDetail.fm_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      // to_date:
      //   this.storesalesDetail && this.storesalesDetail.to_date
      //     ? this.storesalesDetail.to_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      fm_date: this.ManagementPaymentDetail && this.ManagementPaymentDetail.fm_date ? this.ManagementPaymentDetail.fm_date : moment().startOf('month').format('YYYY-MM-DD'),
      to_date: this.ManagementPaymentDetail && this.ManagementPaymentDetail.to_date ? this.ManagementPaymentDetail.to_date : moment().endOf('month').format('YYYY-MM-DD'),
      consolidate: this.ManagementPaymentDetail && this.ManagementPaymentDetail.consolidate ? this.ManagementPaymentDetail.consolidate : 0,
      paymentList: [],
    }
  }

  componentDidMount() {
    if (this.ManagementPaymentDetail) {
      this.StoreSales()
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.ManagementPaymentDetail ? this.ManagementPaymentDetail : {}
    data[name] = value
    StorageService.setSession('ManagementPaymentDetail', data)
    this.ManagementPaymentDetail = StorageService.getSession('ManagementPaymentDetail')
  }

  PaymentReport() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
    }

    axios
      .post(url + ':3003/v1/order/report/sales/payment', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            paymentList: result.data,
          })
          if (result.data.length == 0) {
            this.notificationSystem.addNotification({
              title: <MdWarning />,
              message: 'Data Not Found',
              level: 'warning',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            })
          }
        }
      })
      .catch(error => {
        console.log(error)
        alert(error)
      })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    let data = this.ManagementPaymentDetail ? this.ManagementPaymentDetail : {}
    data[name] = value
    StorageService.setSession('ManagementPaymentDetail', data)
    this.ManagementPaymentDetail = StorageService.getSession('ManagementPaymentDetail')
  }

  CsvNotFound() {
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  render() {
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Row>
          <Col>
            <h5>
              Payment Report <br />
              (Based on Orders Fulfillment Date)
            </h5>
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <Label>Payment Date</Label>
            <Input className="ps-input-small" type="date" name="fm_date" onChange={this.changeHandler} value={this.state.fm_date} />
          </Col>
          <Col md={1}>
            <Label></Label>
            <p
              style={{
                padding: '0.4rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}>
              To
            </p>
          </Col>
          <Col md={2}>
            <Label>Payment Date</Label>
            <Input className="ps-input-small" type="date" name="to_date" onChange={this.changeHandler} value={this.state.to_date} />
          </Col>
          <Col md={2} className="ps-margin-auto-desktop">
            <Button className="ps-input-small" onClick={() => this.PaymentReport()}>
              Search
            </Button>
          </Col>
          <Col></Col>
        </Row>

        <Row>
          <Col>
            <CSVLink
              data={this.state.paymentList}
              headers={headers}
              filename={'PaymentReport_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'}
              onClick={() => {
                if (this.state.paymentList.length < 1) {
                  this.CsvNotFound()
                  return false
                }
              }}>
              <Button type="button" className="ps-input-small theme-button-primary">
                Export
              </Button>
            </CSVLink>
          </Col>
        </Row>

        <Row>
          <Col>
            <Table className="ps-table tb-col-8 ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Store Code</Th>
                  <Th>Order ID</Th>
                  <Th>Payment ID</Th>
                  <Th>Payment Type</Th>
                  <Th>Payment Date</Th>
                  <Th>Payment Amount</Th>
                  <Th>Order Amount</Th>
                  <Th>Order Status</Th>
                  <Th>Payment Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.paymentList.length > 0 &&
                  this.state.paymentList.map((item, index) => {
                    return (
                      <Tr key={index}>
                        <Td>{item.store_code}</Td>
                        <Td>{item.order_id}</Td>
                        <Td>{item.payment_id}</Td>
                        <Td>{item.payment_type}</Td>
                        <Td>{item.payment_date}</Td>
                        <Td>{item.amount}</Td>
                        <Td>{item.total_price}</Td>
                        <Td>{item.order_status}</Td>
                        <Td>{item.payment_status}</Td>
                      </Tr>
                    )
                  })}
              </Tbody>
            </Table>
          </Col>
        </Row>
      </>
    )
  }
}

export default ManagementPayment
